export const STATIC_DATA_ENDPOINTS = {
  PAYOFFS: 'payoffs',
  PAYOFF: 'payoff', // ??
  CAPITAL_PROTECTIONS: 'capital-protections',
  CAPITAL_PROTECTION: 'capital-protection',
  UKSPA_PRODUCT_CODES: 'ukspa-product-codes',
  UNDERLYING_REFERENCE_DATA: 'underlying-reference-data',
  UNDERLYING_ASSETS: 'underlying-assets', // new endpoint replacing 'UNDERLYING_REFERENCE_DATA'
  EXCHANGES: 'exchange',
  ISSUERS: 'issuers/reference',
  CREDIT_RATINGS: 'credit-rating-descriptions',
  CREDIT_RATING: 'credit-rating-description',
  CREDIT_OUTLOOKS: 'credit-outlook-descriptions',
  CREDIT_OUTLOOK: 'credit-outlook-description',
  DEFAULT_RISKS: 'default-risk-descriptions',
  DEFAULT_RISK: 'default-risk-description',
  TRADING_CALENDARS: 'trading-calendars',
  TRADING_CALENDAR: 'trading-calendar',
  TARGET_MARKET: 'target-market',
  REFERENCE_ENTITY: 'reference-entity',
  REFERENCE_OBLIGATION: 'reference-obligation',
  ISSUERS_ENTITY: 'issuers',
  ISSUER_ENTITY: 'issuer',
  LEGAL_PROGRAMMES: 'legal-programme',
  LISTING_VENUES: 'listing-venue',
  AGENTS: 'agent',
  CURRENCIES: 'currencies',
  PHYSICAL_SETTLEMENT_MATRIX: 'physical-settlement-matrix',
  DATA_INGESTION_CONFIG: 'data-ingestion-config',
  DATA_EXPORT_FORMATS: 'data-export-format',
  DATA_EXPORT_FORMATS_ENABLED: 'data-export-format/enabled',
  DESKS: 'desk',
  CONTACTS: 'contact',
  HURDLES_AND_SPREADS: 'hurdle-and-spread',
};
